import type { vendorApiNames } from '../names';
import type { UsernamePasswordAuthentication } from './auth';
import type {
  BaseUpdateVendorApiSettings,
  BaseUrls,
  BaseVendorApi,
  RejectUnauthorized,
} from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';
import type { VendorApiSessionSettings } from './session';

type F5osNames = 'f5osa' | 'f5osc';

/**
 * Base F5OS API settings available from API
 */
type BasePublicF5osApiSettings<Name extends F5osNames> = BaseVendorApi<
  (typeof vendorApiNames)[Name]
> &
  RejectUnauthorized &
  BaseUrls &
  VendorApiHttpAgentSettings &
  VendorApiSessionSettings &
  VendorApiHttpAdvancedSettings;

/**
 * Base F5OS API settings available in backend
 */
type BaseF5osApiSettings<Name extends F5osNames> =
  BasePublicF5osApiSettings<Name> & UsernamePasswordAuthentication;

/**
 * Base F5OS API settings expected on API when updating
 */
type BaseUpdateF5osApiSettings<Name extends F5osNames> =
  BaseUpdateVendorApiSettings<
    BasePublicF5osApiSettings<Name>,
    UsernamePasswordAuthentication
  >;

export type PublicF5osAApiSettings = BasePublicF5osApiSettings<'f5osa'>;
export type PublicF5osCApiSettings = BasePublicF5osApiSettings<'f5osc'>;

export type F5osAApiSettings = BaseF5osApiSettings<'f5osa'>;
export type F5osCApiSettings = BaseF5osApiSettings<'f5osc'>;

export type UpdateF5osAApiSettings = BaseUpdateF5osApiSettings<'f5osa'>;
export type UpdateF5osCApiSettings = BaseUpdateF5osApiSettings<'f5osc'>;
